/**
 * Atal Cloud SaaS Application Configuration
 * Central config for the CTI Intelligence application.
 */

export interface NavItem {
  label: string;
  path: string;
  icon: string;
  roles?: string[];
}

export interface AppConfig {
  appName: string;
  companyName: string;
  logoText: string;
  frontendDomain: string;
  apiDomain: string;
  apiBaseUrl: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  awsRegion: string;
  navItems: NavItem[];
  featureFlags: Record<string, boolean>;
}

const config: AppConfig = {
  appName: 'CTI Intelligence',
  companyName: 'AtalCloud',
  logoText: 'AtalCloud CTI',
  frontendDomain: 'cti.atalcloud.com',
  apiDomain: 'api.cti.atalcloud.com',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_PLACEHOLDER',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || 'placeholder-client-id',
  awsRegion: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  navItems: [
    { label: 'Dashboard', path: '/', icon: 'dashboard' },
    { label: 'Upload CTI', path: '/upload', icon: 'upload' },
    { label: 'Agent Workflow', path: '/workflow', icon: 'workflow' },
    { label: 'Knowledge Search', path: '/search', icon: 'search' },
    { label: 'MITRE Mapping', path: '/mitre', icon: 'shield' },
    { label: 'Risk Scoring', path: '/risk', icon: 'alert' },
    { label: 'Vector Status', path: '/vectors', icon: 'database' },
    { label: 'Reports', path: '/reports', icon: 'report' },
    { label: 'User Management', path: '/users', icon: 'log', roles: ['superadmin'] },
  ],
  featureFlags: {
    enableMockApi: import.meta.env.VITE_MOCK_API === 'true',
    enableDarkMode: false,
    enableExport: true,
    enableAdvancedSearch: true,
  },
};

export default config;
